import styled, { css } from 'styled-components';
import { motion } from 'framer-motion';
import spacing from '../../styles/spacing';
import HBClickable from '../HBClickable/HBClickable';
import { Ttheme } from './HBAccordion';
import { vars } from '../../theme';

interface IItemProps {
    theme: Ttheme;
}

function getThemeStyle({ theme }: IItemProps) {
    if (theme === 'plain') {
        return css`
            border-bottom: 1px solid ${vars.colors.stroke.secondary};
            ${getPadding(16)}
        `;
    }

    // theme === 'regular'
    return css`
        background-color: ${theme === 'light'
            ? vars.colors.surface.item
            : vars.colors.surface.itemInset};
        margin-bottom: ${spacing[12]};
        border-radius: ${vars.radius.xs};
        ${getPadding(12)}
    `;

    function getPadding(paddingBlock: number) {
        return css`
            ${SummaryContainer} {
                padding-block: ${paddingBlock}px;
            }
            ${DetailsContainer}:before {
                // using pseudo elements instead of padding to avoid having to animate padding as well
                content: '';
                display: block;
                height: 4px;
            }
            ${DetailsContainer}:after {
                content: '';
                display: block;
                height: ${paddingBlock}px;
            }
        `;
    }
}

export const Accordion = styled.section`
    font-family: ${vars.fonts.body};
    width: 100%;
`;

export const AccordionItem = styled.div<IItemProps>`
    color: ${vars.colors.text.secondary};
    ${getThemeStyle}
`;

export const SummaryContainer = styled(HBClickable)`
    display: flex;
    padding-inline: 20px;
`;

export const SummaryContent = styled.div`
    font-size: 18px;
    font-weight: 600;
    flex: 1;
`;

export const DetailsContainer = styled(motion.div)`
    font-size: 18px;
    padding-inline: 20px;
`;

export const IconContainer = styled.div`
    padding-top: 3px;
`;
